import { Paginator } from 'primereact/paginator';

import styles from './Pagination.module.scss';
import { IPaginationProps } from './IPaginationProps';

const Pagination = ({
  totalRecords,
  first,
  rows,
  onPageChange,
}: IPaginationProps): JSX.Element => {
  return (
    <Paginator
      className={styles.paginator}
      template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      totalRecords={totalRecords}
      rows={rows}
      first={first}
      onPageChange={onPageChange}
    />
  );
};

export default Pagination;
